import { NgModule } from "@angular/core";
import { BadgesModule } from "@webapp/badges/badges.module";
import { ReflectionsModule } from "@webapp/reflections/reflections.module";
import { TeamsModule } from "@webapp/teams/teams.module";
import { PeopleRoutingModule } from "./people-routing.module";

@NgModule({
  imports: [PeopleRoutingModule, BadgesModule, TeamsModule, ReflectionsModule],
})
export class PeopleModule {}
